import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { IFleetInitialState } from "./types";
import initialState from "./state";

const resetState: CaseReducer<IFleetInitialState, PayloadAction> = () => {
  return initialState;
};

const setSelectedDrone: CaseReducer<IFleetInitialState, PayloadAction<IFleetInitialState['selectedDrone']>> = (state, action) => {
  state.selectedDrone = action.payload;
};

export default { resetState, setSelectedDrone };